'use client';

import { notFound } from 'next/navigation';
import ProjectDetail from '@/components/Desktop/ProjectDetail';
import ProjectMobileDetail from '@/components/Mobile/ProjectDetailMobile';
import { useIsMobile } from '@/components/DeviceContext';
import { useProjects } from '@/components/ProjectsContext';
import { useMemo } from 'react';

interface Props {
  slug: string;
}

export default function ProjectDetailPageContent({ slug }: Props) {
  const isMobile = useIsMobile();
  const projects = useProjects();

  const project = useMemo(
    () => projects.find((project) => project.slug === slug),
    [projects, slug],
  );
  
  const desktopPresetIndex = useMemo(() => Math.floor(Math.random() * 2), [slug]);

  if (!project) {
    notFound();
  }
  
  return isMobile
    ? <ProjectMobileDetail project={project} projects={projects} />
    : <ProjectDetail key={project.id} project={project} projects={projects} presetIndex={desktopPresetIndex} />;
}
